import { ShareableType } from '@bindoc-projects/resource-domain-lib';

/**
 * The scopes the resource picker can browse. A subset of
 * {@link import('../shareables-overview/shareables-overview.models').ViewTab}:
 * the picker has no recycle bin (archived items are not pickable).
 */
export type PickerViewTab = 'recent' | 'shareables' | 'grants' | 'group';

/** Which scope the picker's content pane currently shows. */
export interface PickerView {
  readonly tab: PickerViewTab;
  /** Set for `tab: 'group'` — the company group being browsed. */
  readonly groupId?: string;
  readonly groupName?: string;
}

/**
 * Narrowing criteria of the picker's search-filter popover. One facet for now;
 * the object shape keeps a second one an additive change (mirrors
 * `AysClinicSearchCriteria`).
 */
export interface ResourcePickerCriteria {
  /**
   * Types the user narrowed to. Empty means "no extra restriction" — the
   * picker then falls back to its host's allowed types, never to *all* types.
   */
  readonly types: readonly ShareableType[];
}

/** An unset criteria object — every facet empty. */
export const RESOURCE_PICKER_CRITERIA_EMPTY: ResourcePickerCriteria = {
  types: [],
};

/** Number of facets currently set — drives the filter button's badge. */
export function resourcePickerCriteriaActiveCount(
  criteria: ResourcePickerCriteria,
): number {
  return criteria.types.length > 0 ? 1 : 0;
}
